<template>
    <BreadCrumb PageTitle="Ajout d'un reglement groupe" />
    <AddReglementGroupe />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddReglementGroupe from "../../components/Reglement/AddReglementGroupe.vue";

    export default defineComponent({
        name: "AddReglementGroupePage",
        components: {
            BreadCrumb,
            AddReglementGroupe,
        },
    });
</script>